// import React, { useEffect, useState } from "react";
// import {
//   Alert,
//   Avatar,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   Grid,
//   Snackbar,
//   TextField,
//   Typography,
// } from "@mui/material";
// import PersonIcon from "@mui/icons-material/Person";
// import ApiServices from "../../Utils/ApiServices";
// import CustomerAddress from "./CustomerAddress";

// const CustomerProfile = () => {
//   const customerId = localStorage.getItem("customer_id");
//   const accessToken = localStorage.getItem("access_token");
//   console.log("CustomerProfile rendered with customerId:", customerId);
//   console.log("CustomerProfile rendered with accessToken:", accessToken);

//   const [profile, setProfile] = useState(null);
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const showMessage = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };



//   const fetchProfile = async () => {
//     if (!customerId || !accessToken) {
//       showMessage("Customer login details not found. Please login again.", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await ApiServices.get(
//         `/api/v1/customers/${customerId}/profile/`,
//         { Authorization: `Bearer ${accessToken}` }
//       );

//       const data = res?.data || res;
//       setProfile(data);
//       setFormData({
//         first_name: data?.first_name || "",
//         last_name: data?.last_name || "",
//         email: data?.email || "",
//       });
//     } catch (error) {
//       showMessage(
//         error?.response?.data?.detail || "Failed to load profile.",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProfile();
//   }, []);

//   const validateProfile = () => {
//     const newErrors = {};

//     if (!formData.first_name.trim()) {
//       newErrors.first_name = "First name is required";
//     } else if (formData.first_name.trim().length < 2) {
//       newErrors.first_name = "First name must be at least 2 characters";
//     }

//     if (!formData.last_name.trim()) {
//       newErrors.last_name = "Last name is required";
//     } else if (formData.last_name.trim().length < 2) {
//       newErrors.last_name = "Last name must be at least 2 characters";
//     }

//     if (!formData.email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (
//       !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.email.trim())
//     ) {
//       newErrors.email = "Enter a valid email address";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       [name]: "",
//     }));
//   };

//   const handleUpdateProfile = async () => {
//     if (!validateProfile()) return;

//     try {
//       setSaving(true);

//       const payload = {
//         first_name: formData.first_name.trim(),
//         last_name: formData.last_name.trim(),
//         email: formData.email.trim(),
//       };

//       const res = await ApiServices.patch(
//         `/api/v1/customers/${customerId}/profile/`,
//         payload,
//         { Authorization: `Bearer ${accessToken}` }
//       );

//       const data = res?.data || res;
//       setProfile(data);

//       showMessage("Profile updated successfully.", "success");
//     } catch (error) {
//       showMessage(
//         error?.response?.data?.detail || "Failed to update profile.",
//         "error"
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#f6f8fb", minHeight: "100vh" }}>
//       <Box sx={{ maxWidth: 1200, mx: "auto" }}>
//         <Typography variant="h4" fontWeight={700} gutterBottom>
//           My Profile
//         </Typography>

//         <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
//           Manage your personal details and saved delivery addresses.
//         </Typography>

//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
//                 <CardContent sx={{ textAlign: "center", p: 4 }}>
//                   <Avatar
//                     sx={{
//                       width: 90,
//                       height: 90,
//                       mx: "auto",
//                       mb: 2,
//                       bgcolor: "primary.main",
//                     }}
//                   >
//                     <PersonIcon sx={{ fontSize: 46 }} />
//                   </Avatar>

//                   <Typography variant="h6" fontWeight={700}>
//                     {profile?.first_name} {profile?.last_name}
//                   </Typography>

//                   <Typography color="text.secondary" sx={{ mt: 0.5 }}>
//                     {profile?.phone}
//                   </Typography>

//                   <Typography color="text.secondary" sx={{ mt: 0.5 }}>
//                     {profile?.email}
//                   </Typography>

//                   <Alert severity={profile?.is_active ? "success" : "warning"} sx={{ mt: 3 }}>
//                     Account {profile?.is_active ? "Active" : "Inactive"}
//                   </Alert>
//                 </CardContent>
//               </Card>
//             </Grid>

//             <Grid item xs={12} md={8}>
//               <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
//                 <CardContent sx={{ p: { xs: 2, md: 3 } }}>
//                   <Typography variant="h6" fontWeight={700} gutterBottom>
//                     Profile Information
//                   </Typography>

//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12} sm={6}>
//                       <TextField
//                         fullWidth
//                         label="First Name"
//                         name="first_name"
//                         value={formData.first_name}
//                         onChange={handleChange}
//                         error={Boolean(errors.first_name)}
//                         helperText={errors.first_name}
//                       />
//                     </Grid>

//                     <Grid item xs={12} sm={6}>
//                       <TextField
//                         fullWidth
//                         label="Last Name"
//                         name="last_name"
//                         value={formData.last_name}
//                         onChange={handleChange}
//                         error={Boolean(errors.last_name)}
//                         helperText={errors.last_name}
//                       />
//                     </Grid>

//                     <Grid item xs={12} sm={6}>
//                       <TextField
//                         fullWidth
//                         label="Email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         error={Boolean(errors.email)}
//                         helperText={errors.email}
//                       />
//                     </Grid>

//                     <Grid item xs={12} sm={6}>
//                       <TextField
//                         fullWidth
//                         label="Phone"
//                         value={profile?.phone || ""}
//                         disabled
//                         helperText="Phone number is read-only"
//                       />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <Button
//                         variant="contained"
//                         size="large"
//                         onClick={handleUpdateProfile}
//                         disabled={saving}
//                       >
//                         {saving ? "Saving..." : "Update Profile"}
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </Card>
//             </Grid>

//             <Grid item xs={12}>
//               <CustomerAddress
//                 customerId={customerId}
//                 accessToken={accessToken}
//               />
//             </Grid>
//           </Grid>
//         )}
//       </Box>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3500}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           severity={snackbar.severity}
//           variant="filled"
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default CustomerProfile;


import React, { useEffect, useState } from "react";
import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import LocalPizzaRoundedIcon from "@mui/icons-material/LocalPizzaRounded";
import RestaurantMenuRoundedIcon from "@mui/icons-material/RestaurantMenuRounded";
import ApiServices from "../../Utils/ApiServices";
import CustomerAddress from "./CustomerAddress";

const REDGRAD =
  "linear-gradient(135deg, #7A0E0E 0%, #B71C1C 50%, #E64A19 100%)";
const AMBERGRAD =
  "linear-gradient(135deg, #FF8F00 0%, #FFB300 50%, #FFC107 100%)";
const CREAM = "#FFF8F0";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2.5,
    backgroundColor: "#FFF8F0",
    transition: "all .25s ease",
    "& fieldset": { borderColor: "rgba(122,14,14,0.18)" },
    "&:hover fieldset": { borderColor: "#E64A19" },
    "&.Mui-focused fieldset": { borderColor: "#B71C1C", borderWidth: 2 },
    "&.Mui-focused": {
      boxShadow: "0 0 0 4px rgba(183,28,28,0.10)",
      backgroundColor: "#fff",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#B71C1C" },
};

const CustomerProfile = () => {
  const customerId = localStorage.getItem("customer_id");
  const accessToken = localStorage.getItem("access_token");

  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showMessage = (message, severity = "success") =>
    setSnackbar({ open: true, message, severity });

  const fetchProfile = async () => {
    if (!customerId || !accessToken) {
      showMessage("Customer login details not found. Please login again.", "error");
      return;
    }
    try {
      setLoading(true);
      const res = await ApiServices.get(
        `/api/v1/customers/${customerId}/profile/`,
        { Authorization: `Bearer ${accessToken}` }
      );
      const data = res?.data || res;
      setProfile(data);
      setFormData({
        first_name: data?.first_name || "",
        last_name: data?.last_name || "",
        email: data?.email || "",
      });
    } catch (error) {
      showMessage(
        error?.response?.data?.detail || "Failed to load profile.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateProfile = () => {
    const newErrors = {};
    if (!formData.first_name.trim()) newErrors.first_name = "First name is required";
    else if (formData.first_name.trim().length < 2)
      newErrors.first_name = "First name must be at least 2 characters";

    if (!formData.last_name.trim()) newErrors.last_name = "Last name is required";
    else if (formData.last_name.trim().length < 2)
      newErrors.last_name = "Last name must be at least 2 characters";

    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.email.trim()))
      newErrors.email = "Enter a valid email address";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const handleUpdateProfile = async () => {
    if (!validateProfile()) return;
    try {
      setSaving(true);
      const payload = {
        first_name: formData.first_name.trim(),
        last_name: formData.last_name.trim(),
        email: formData.email.trim(),
      };
      const res = await ApiServices.patch(
        `/api/v1/customers/${customerId}/profile/`,
        payload,
        { Authorization: `Bearer ${accessToken}` }
      );
      const data = res?.data || res;
      setProfile(data);
      showMessage("Profile updated successfully.", "success");
    } catch (error) {
      showMessage(
        error?.response?.data?.detail || "Failed to update profile.",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  const initials =
    `${profile?.first_name?.[0] || ""}${profile?.last_name?.[0] || ""}`.toUpperCase() ||
    "PT";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 3, md: 6 },
        px: { xs: 2, md: 4 },
        background: `
          radial-gradient(1000px 500px at 0% 0%, rgba(255,179,0,0.18), transparent 60%),
          radial-gradient(900px 500px at 100% 10%, rgba(230,74,25,0.18), transparent 60%),
          ${CREAM}
        `,
      }}
    >
      {/* Floating decorative blobs */}
      <Box
        component={motion.div}
        animate={{ y: [0, -18, 0] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
        sx={{
          position: "absolute",
          top: 80,
          right: 60,
          width: 120,
          height: 120,
          borderRadius: "50%",
          background: AMBERGRAD,
          opacity: 0.15,
          filter: "blur(40px)",
          pointerEvents: "none",
        }}
      />

      <Box sx={{ maxWidth: 1200, mx: "auto", position: "relative" }}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 1 }}>
            <Box
              sx={{
                width: 52,
                height: 52,
                borderRadius: "16px",
                background: REDGRAD,
                display: "grid",
                placeItems: "center",
                boxShadow: "0 10px 24px rgba(183,28,28,0.35)",
              }}
            >
              <RestaurantMenuRoundedIcon sx={{ color: "#fff", fontSize: 28 }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: 800,
                  fontSize: { xs: 28, md: 36 },
                  background: REDGRAD,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  lineHeight: 1.1,
                }}
              >
                My Profile
              </Typography>
              <Typography sx={{ color: "#6b4a3a", fontSize: 14 }}>
                Manage your details and saved delivery addresses
              </Typography>
            </Box>
          </Stack>
        </motion.div>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
            <CircularProgress sx={{ color: "#B71C1C" }} />
          </Box>
        ) : (
          <Grid container spacing={3} sx={{ mt: 1 }}>
            {/* Profile summary card */}
            <Grid item xs={12} md={4}>
              <motion.div
                initial={{ opacity: 0, x: -24 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.55 }}
              >
                <Card
                  sx={{
                    borderRadius: 4,
                    overflow: "hidden",
                    border: "1px solid rgba(122,14,14,0.08)",
                    boxShadow: "0 18px 40px rgba(122,14,14,0.12)",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.85), rgba(255,248,240,0.85))",
                    backdropFilter: "blur(20px)",
                    position: "relative",
                  }}
                >
                  {/* Banner */}
                  <Box
                    sx={{
                      height: 110,
                      background: REDGRAD,
                      position: "relative",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        inset: 0,
                        background:
                          "radial-gradient(circle at 30% 50%, rgba(255,179,0,0.4), transparent 60%)",
                      },
                    }}
                  >
                    <LocalPizzaRoundedIcon
                      sx={{
                        position: "absolute",
                        right: 16,
                        top: 16,
                        color: "rgba(255,255,255,0.35)",
                        fontSize: 60,
                      }}
                    />
                  </Box>

                  <CardContent sx={{ textAlign: "center", p: 3, pt: 0 }}>
                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      transition={{ type: "spring", stiffness: 300 }}
                    >
                      <Avatar
                        sx={{
                          width: 110,
                          height: 110,
                          mx: "auto",
                          mt: -7,
                          mb: 2,
                          fontSize: 38,
                          fontWeight: 800,
                          background: AMBERGRAD,
                          color: "#7A0E0E",
                          border: "5px solid #fff",
                          boxShadow: "0 10px 24px rgba(0,0,0,0.15)",
                        }}
                      >
                        {initials}
                      </Avatar>
                    </motion.div>

                    <Typography
                      variant="h6"
                      fontWeight={800}
                      sx={{ color: "#2A1810" }}
                    >
                      {profile?.first_name} {profile?.last_name}
                    </Typography>

                    <Stack
                      direction="row"
                      spacing={0.5}
                      alignItems="center"
                      justifyContent="center"
                      sx={{ mt: 0.5, color: "#6b4a3a" }}
                    >
                      <PhoneIphoneRoundedIcon sx={{ fontSize: 16 }} />
                      <Typography fontSize={14}>{profile?.phone}</Typography>
                    </Stack>

                    <Stack
                      direction="row"
                      spacing={0.5}
                      alignItems="center"
                      justifyContent="center"
                      sx={{ mt: 0.5, color: "#6b4a3a" }}
                    >
                      <EmailRoundedIcon sx={{ fontSize: 16 }} />
                      <Typography fontSize={14}>{profile?.email}</Typography>
                    </Stack>

                    <Divider sx={{ my: 2.5 }} />

                    <Chip
                      icon={
                        <VerifiedRoundedIcon
                          sx={{ color: "#fff !important", fontSize: 18 }}
                        />
                      }
                      label={`Account ${profile?.is_active ? "Active" : "Inactive"}`}
                      sx={{
                        background: profile?.is_active
                          ? "linear-gradient(135deg,#2E7D32,#66BB6A)"
                          : "linear-gradient(135deg,#9E9E9E,#BDBDBD)",
                        color: "#fff",
                        fontWeight: 700,
                        px: 1.5,
                        height: 32,
                      }}
                    />

                    <Box
                      sx={{
                        mt: 3,
                        p: 2,
                        borderRadius: 2.5,
                        background:
                          "linear-gradient(135deg, rgba(255,179,0,0.12), rgba(230,74,25,0.10))",
                        border: "1px dashed rgba(230,74,25,0.3)",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 12,
                          color: "#7A0E0E",
                          fontWeight: 600,
                          letterSpacing: 0.4,
                          textTransform: "uppercase",
                        }}
                      >
                        🍕 Pizza Town Member
                      </Typography>
                      <Typography sx={{ fontSize: 13, color: "#6b4a3a", mt: 0.5 }}>
                        Earn rewards on every order
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>

            {/* Edit form */}
            <Grid item xs={12} md={8}>
              <motion.div
                initial={{ opacity: 0, x: 24 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.55, delay: 0.1 }}
              >
                <Card
                  sx={{
                    borderRadius: 4,
                    border: "1px solid rgba(122,14,14,0.08)",
                    boxShadow: "0 18px 40px rgba(122,14,14,0.10)",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.92), rgba(255,248,240,0.92))",
                    backdropFilter: "blur(20px)",
                  }}
                >
                  <CardContent sx={{ p: { xs: 2.5, md: 4 } }}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1.5}
                      sx={{ mb: 3 }}
                    >
                      <BadgeRoundedIcon sx={{ color: "#B71C1C" }} />
                      <Typography
                        variant="h6"
                        fontWeight={800}
                        sx={{ color: "#2A1810" }}
                      >
                        Profile Information
                      </Typography>
                    </Stack>

                    <Grid container spacing={2.5}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="First Name"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleChange}
                          error={Boolean(errors.first_name)}
                          helperText={errors.first_name}
                          sx={inputSx}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonOutlineRoundedIcon
                                  sx={{ color: "#B71C1C" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Last Name"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleChange}
                          error={Boolean(errors.last_name)}
                          helperText={errors.last_name}
                          sx={inputSx}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonOutlineRoundedIcon
                                  sx={{ color: "#B71C1C" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Email"
                          name="email"
                          disabled
                           helperText="Email is read-only"
                          value={formData.email}
                          onChange={handleChange}
                          error={Boolean(errors.email)}
                          // helperText={errors.email}
                          sx={inputSx}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailRoundedIcon sx={{ color: "#B71C1C" }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Phone"
                          value={profile?.phone || ""}
                          disabled
                          helperText="Phone number is read-only"
                          sx={{
                            ...inputSx,
                            "& .MuiOutlinedInput-root.Mui-disabled": {
                              backgroundColor: "rgba(122,14,14,0.04)",
                            },
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIphoneRoundedIcon
                                  sx={{ color: "#9E9E9E" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Box
                          component={motion.div}
                          whileHover={{ y: -2 }}
                          whileTap={{ scale: 0.98 }}
                          sx={{ display: "inline-block", mt: 1 }}
                        >
                          <Button
                            variant="contained"
                            size="large"
                            onClick={handleUpdateProfile}
                            disabled={saving}
                            startIcon={
                              saving ? (
                                <CircularProgress size={18} sx={{ color: "#fff" }} />
                              ) : (
                                <SaveRoundedIcon />
                              )
                            }
                            sx={{
                              px: 4,
                              py: 1.4,
                              borderRadius: 999,
                              fontWeight: 700,
                              fontSize: 15,
                              color: "#fff",
                              background: REDGRAD,
                              boxShadow: "0 12px 28px rgba(183,28,28,0.35)",
                              "&:hover": {
                                background: REDGRAD,
                                boxShadow: "0 16px 36px rgba(183,28,28,0.5)",
                              },
                              "&.Mui-disabled": {
                                color: "rgba(255,255,255,0.85)",
                                background:
                                  "linear-gradient(135deg,#a85a5a,#c97050)",
                              },
                            }}
                          >
                            {saving ? "Saving..." : "Update Profile"}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>

            {/* Addresses */}
            <Grid item xs={12}>
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.55, delay: 0.2 }}
              >
                <Card
                  sx={{
                    borderRadius: 4,
                    border: "1px solid rgba(122,14,14,0.08)",
                    boxShadow: "0 18px 40px rgba(122,14,14,0.08)",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.92), rgba(255,248,240,0.92))",
                    backdropFilter: "blur(20px)",
                    p: { xs: 1, md: 2 },
                  }}
                >
                  <CustomerAddress
                    customerId={customerId}
                    accessToken={accessToken}
                  />
                </Card>
              </motion.div>
            </Grid>
          </Grid>
        )}
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3500}
        onClose={() => setSnackbar((p) => ({ ...p, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          onClose={() => setSnackbar((p) => ({ ...p, open: false }))}
          sx={{ borderRadius: 2, fontWeight: 600 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CustomerProfile;
